import { LowContentLayout } from "@/pages/layouts";
import { useTranslation } from "react-i18next";
import AlertBlock from "../../../components/alerts/alertBlock/AlertBlock";
import "./ErrorNotice.scss";

export const ErrorNotice: React.FC<{ title: string; onBackBtn?: (() => void) | undefined }> = (props) => {
  const { t } = useTranslation();
  const { title, onBackBtn } = props;
  const isHideSubmitSection = title ? false : true;

  return (
    <div id="error-notice" className={`${!title ? "error-notice-full" : "error-notice-embedded"}`}>
      <LowContentLayout
        title={title}
        hideSubmitSection={isHideSubmitSection}
        body={
          <AlertBlock
            title={t("errorNote.title")}
            body={
              <p>
                <span>{t("errorNote.body.p1")}</span>
              </p>
            }
            isError={true}
          />
        }
        onBackBtn={onBackBtn}
      />
    </div>
  );
};

export default ErrorNotice;
